import React from "react"

import { useTranslation } from "react-i18next"

import { EmptyEstimatedQuoteImage, EmptyEstimatedQuoteText, EmptyEstimatedQuoteTitle, EmptyEstimatedQuoteWrapper } from "./styles"

const EMPTY_ESTIMATED_QUOTE_IMG = require("../../../../../assets/img/empty-estimated-quote.svg")

export const EmptyEstimatedQuote = () => {
  const { t: translate } = useTranslation();

  return (
    <EmptyEstimatedQuoteWrapper>
      <EmptyEstimatedQuoteImage src={EMPTY_ESTIMATED_QUOTE_IMG} alt="empty-estimated-quote-img"/>
      <EmptyEstimatedQuoteTitle>{translate("oops")}</EmptyEstimatedQuoteTitle>
      <EmptyEstimatedQuoteText>{translate("theresNoEstimatesAvailableToView")}</EmptyEstimatedQuoteText>
    </EmptyEstimatedQuoteWrapper>
  )
}